export const X_LBRY_AUTH_TOKEN = 'X-Lbry-Auth-Token';
// Additional parameter for apiCall() to skip sending the auth token.
// NO_AUTH will be stripped from the parameter object before sending out.
export const NO_AUTH = 'no_auth';
